<template>
  <div class="main-container">
    <div class="free-banner">
      <div class="main-text-box">
        <h1>矩尺全栈智能流量管理平台</h1>
        <h2>试用中心</h2>
      </div>
    </div>
    <div class="feature">
      <div class="feature-box">
        <h2>矩尺全栈智能流量管理平台</h2>
        <div class="free-title forever">免费版</div>
        <p>免费版保留了商业版分布式的产品架构，以应用负载均衡功能为核心，支持静态资源发布功能；配合应用实时监控、SSL卸载、智能应用代理、应用加速、应用流量大数据展现等技术，实现流量的智能分发、应用协议转换、应用性能监控、部署拓扑和虚拟服务拓扑展示等功能，该版本产品为用户提供永久免费的代理服务体验平台。</p>
        <div>
          <el-button class="nav-button" @click="goFree">
            <a ref="downloadFree" :href="freeLink" target="_blank" @click.stop>立即安装</a>
          </el-button>
        </div>
      </div>
      <div class="feature-box">
        <h2>矩尺全栈智能流量管理平台</h2>
        <div class="free-title">商业试用版</div>
        <p>商业试用版涵盖商业版所有功能，如服务器负载均衡、静态资源发布、全局负载均衡、第三方纳管等功能；提供开放的API接口，可与第三方平台对接；对系统和服务产生的异常可提供告警通知，并可通过脚本与第三方通信平台对接，实现智能运维；该版本产品为用户提供3个月的全功能测试平台。</p>
        <div>
          <el-button class="nav-button" @click="goTrial">
            <a ref="getTrail" href="#downloadTrail" @click.stop>获取链接</a>
          </el-button>
        </div>
      </div>
      <!-- <img class="feature-left" src="@/assets/imgs/free-suggestion.png" alt="免费版建议架构">
      <div class="feature-right">
        <h1 class="h1-title">矩尺分布式应用交付平台-免费版</h1>
        <div class="title-devide-line"></div>
        <p>矩尺分布式应用交付平台免费版，保留了商业版分布式的产品架构，以应用负载均衡功能为核心，配合应用实时监控、SSL卸载、智能应用代理、应用加速、应用流量大数据展现等技术，实现流量的智能分发、应用协议转换、应用性能监控、部署拓扑和虚拟服务拓扑展示，为用户提供便捷、可靠的全代理服务体验平台。</p>
      </div> -->
    </div>
    <ProductTitle title="建议部署架构" align="center"/>
    <div style="padding: 30px 0;background-color: #fff;">
      <img style="margin: 0 auto;" src="@/assets/imgs/free-suggestion.png" alt="免费版建议架构">
    </div>
    <ProductTitle title="免费版与商业版主要功能对比" align="center"/>
    <div class="compare">
      <table>
        <thead>
          <tr>
            <th>项目/主要功能</th>
            <th>指标/功能项</th>
            <th>免费版</th>
            <th>商业试用版</th>
            <th>商业版</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>授权</td>
            <td>vCPU授权数量</td>
            <td>4vCPU授权</td>
            <td>4vCPU授权</td>
            <td>通过购买获得vCPU授权</td>
          </tr>
          <tr>
            <td>授权期限</td>
            <td>使用期限</td>
            <td>永久免费</td>
            <td>3个月</td>
            <td>1年（期满后正常使用，但不再提供原厂技术支持和升级服务）</td>
          </tr>
          <tr>
            <td rowspan="2">全局负载均衡</td>
            <td>静态就近性</td>
            <td><span class="icon-cha"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td>DNS解析</td>
            <td><span class="icon-cha"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td rowspan="9">服务器负载均衡</td>
            <td>健康检查</td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td>分发规则</td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td>分发策略</td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td>SSL卸载（国密）</td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td>部署拓扑</td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td>虚拟服务拓扑</td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td>IP集合管理</td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td>应用失效保障页面</td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td>静态资源（web页面展示）</td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td rowspan="9">智能运维</td>
            <td>第三方负载均衡纳管（监控、分析）</td>
            <td><span class="icon-cha"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span>（单独购买授权）</td>
          </tr>
          <tr>
            <td>日志分析</td>
            <td><span class="icon-cha"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td>事件告警</td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td>异常告警</td>
            <td><span class="icon-cha"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td>抓包分析</td>
            <td><span class="icon-cha"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td>邮件通知</td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td>脚本通知</td>
            <td><span class="icon-cha"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td>SNMP管理（Agent、Traps）</td>
            <td><span class="icon-cha"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td>开放的API</td>
            <td><span class="icon-cha"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td rowspan="3">路由功能</td>
            <td>静态路由</td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td>动态路由</td>
            <td><span class="icon-cha"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
          <tr>
            <td>VRF</td>
            <td><span class="icon-cha"></span></td>
            <td><span class="icon-gou"></span></td>
            <td><span class="icon-gou"></span></td>
          </tr>
        </tbody>
      </table>
    </div>
    <ProductTitle id="downloadTrail" title="获取链接" align="center"/>
    <div class="download">
      <table class="business-table">
        <thead>
          <tr>
            <th class="version-col">版本</th>
            <th class="architect-col">产品架构</th>
            <th class="desc-col">说明</th>
            <th class="download-col">获取链接</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>免费版</td>
            <td>n6S-x86/ARM*</td>
            <td>支持x86和ARM等CPU架构服务器及虚拟化环境，支持主流Linux环境操作系统**，保留主要功能；（永久免费）</td>
            <td>
              <a :href="freeLink" target="_blank">立即安装（配置指南）</a>
            </td>
          </tr>
          <tr>
            <td>商业试用版</td>
            <td>n6S-x86/ARM</td>
            <td>支持x86和ARM等CPU架构服务器及虚拟化环境，支持主流Linux环境操作系统**，含矩尺负载均衡全功能；（试用期3个月）</td>
            <td>
              <a :href="`https://docs.n6delta.com/config/buy/how.html#免费试用90天商业版`" target="_blank">获取商业试用版</a>
            </td>
          </tr>
          <tr>
            <td>商业版</td>
            <td>n6S-x86/ARM</td>
            <td>支持x86和ARM等CPU架构服务器及虚拟化环境，支持主流Linux环境操作系统**，含矩尺负载均衡全功能；（1年服务）</td>
            <td>
              <a :href="`https://docs.n6delta.com/config/buy/how.html#购买正式商业版`" target="_blank">获取商业版</a>
            </td>
          </tr>
        </tbody>
      </table>
      <p class="table-note">*免费版n6S-x86架构产品支持联网或离线安装，n6S-ARM架构产品支持离线安装。</p>
      <p class="table-note">**支持主流Linux环境，可适配统信、麒麟、Red Hat、CentOS、openEuler、 Ubuntu等操作系统。</p>
      <br/>
    </div>
    <BusinessDialog :version="businessDialogVersion" :visible.sync="isShowBusinessDialog" />
  </div>
</template>

<script>
import ProductTitle from '@/components/ProductTitle.vue'
import TitlePoint from '@/components/TitlePoint.vue'
import BusinessDialog from '@/components/BusinessDialog.vue'


export default {
  components: {
    ProductTitle,
    TitlePoint,
    BusinessDialog
  },
  data() {
    return {
      isShowBusinessDialog: false,
      businessDialogVersion: 'business',
      freeLink: `https://docs.n6delta.com/config/quick-guide/install.html`
    }
  },
  methods: {
    goFree() {
      this.$refs.downloadFree.click()
    },
    goTrial() {
      this.$refs.getTrail.click()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '~@/assets/imgs/sprite.css';
.free-banner{
  height: 300px;
  background-image: url('~@/assets/imgs/product-banner.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 50px 115px;
  display: flex;
  flex-direction: column;
  // align-items: center;
  justify-content: center;
  color: #fff;
  .main-text-box{
    width: 420px;
    h1 {
      margin-bottom: 20px;
    }
    .title-devide-line{
      width: 155px!important;
    }
    h2 {
      margin-bottom: 20px;
    }
    p {
      margin: 0 0 20px 0;
    }
    .el-button{
      background-color: #00b0f0;
      border-color: #00b0f0;
      a{
        color: #ffffff;
      }
      &:hover a{
        color: $primaryColor;
      }
    }
  }
}
.feature {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 50px;
  padding: 30px 0;
  .feature-box{
    width: 550px;
    height: 340px;
    border: 1px solid #41719c;
    text-align: center;
    padding: 30px;
    .free-title{
      margin-top: 10px;
      position: relative;
      font-size: 30px;
      color: #4472c4;
      &.forever::after{
        position: absolute;
        content: '永久免费';
        padding-left: 10px;
        color: #c55a11;
        font-size: 14px;
        bottom: 2px;
      }
    }
    p{
      text-align: left;
      text-indent: 2rem;
    }
    .nav-button{
      background-color: #00b0f0;
      border-color: #00b0f0;
      a{
        color: #ffffff;
      }
      &:hover{
        background-color: #00b0f01e;
        border-color: #00b0f0;
      }
      &:hover a{
        color: $primaryColor;
      }
    }
  }
}
// .feature {
//   width: 100%;
//   height: 387px;
//   display: flex;
//   padding: 0 80px;
//   .feature-left {
//     width: 35%;
//     text-align: left;
//     margin-right: 120px;
//     margin-top: 70px;
//   }
//   .feature-right {
//     text-align: left;
//     .h1-title {
//       margin-top: 80px;
//       padding: 10px 0;
//       font-weight: 400;
//       color: #171718;
//       line-height: 35px;
//     }
//     p {
//       text-indent: 2rem;
//       line-height: 2rem;
//     }
//   }
//   img {
//     height: 210px;
//   }
// }
.compare,.download {
  background-color: #fff;
  table{
    --table-border: 1px solid #909399;
    border-spacing: 0;
    width: 1280px;
    margin: 0 auto;
    border: var(--table-border);
    border-bottom: none;
    border-right: none;
    th,td{
      border-bottom: var(--table-border);
      border-right: var(--table-border);
    }
  }
  .doc-btn{
    background-color: #f4f8fa;
    border-color: #c2c2c4;
    a{
      color: #171718;
    }
    &:hover a{
      color: $primaryColor;
    }
  }
}
.icon-cha,.icon-gou{
  width: 12px;
  height: 12px;
  display: inline-block;
  vertical-align: middle;
}
.business-table{
  // .version-col{
  //   width: 118px;
  // }
  // .architect-col{
  //   width: 150px;
  // }
  .desc-col{
    width: 592px;
  }
  // .download-col{
  //   width: 200px;
  // }
}
.table-note{
  text-align: left;
  padding-left: 80px;
  font-size: smaller;
}
.business-download{
  background-color: #fff;
  text-align: center;
  margin-bottom: 50px;
}
</style>